import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  deleteEmail,
  fetchEmails,
  makePrimary,
  reinitiateEmail,
  resetEmailState,
  resendConfirmation,
} from '../actions/emails';
import Emails from '../components/profile/Emails';
import EmailDeleteModal from '../components/profile/EmailDeleteModal';
import EmailConfirmationModal from '../components/profile/EmailConfirmationModal';
import EmailVerificationModal from '../components/profile/EmailVerificationModal';

export class ProfileEmails extends Component {
  static propTypes = {
    actionFetchEmails: PropTypes.func.isRequired,
    actionReinitiateEmail: PropTypes.func,
    actionResetEmailState: PropTypes.func,
    emails: PropTypes.arrayOf(PropTypes.shape({})),
    error: PropTypes.string,
    inspectionId: PropTypes.string,
    isFetching: PropTypes.bool.isRequired,
    isSuccess: PropTypes.bool,
    useOtpFlow: PropTypes.bool,
  };

  static defaultProps = {
    emails: [],
    error: '',
  };

  state = {
    deleteModalEmail: null,
    deleteModalIsOpen: false,
    confirmationModalEmail: {},
    confirmationModalIsOpen: false,
    isReinitiating: false,
    pendingReinitiate: false,
    verificationModalIsOpen: false,
    verificationEmailAddress: '',
  };

  componentDidMount() {
    const { isFetching, actionFetchEmails } = this.props;
    if (!isFetching) {
      actionFetchEmails();
    }
  }

  componentDidUpdate(prevProps) {
    const { inspectionId, isSuccess } = this.props;
    const { verificationEmailAddress, pendingReinitiate } = this.state;

    if (
      isSuccess &&
      inspectionId &&
      prevProps.inspectionId !== inspectionId &&
      verificationEmailAddress &&
      pendingReinitiate
    ) {
      this.setState({
        verificationModalIsOpen: true,
        pendingReinitiate: false,
      });
    }
  }

  handlePrimary = (index) => {
    const { actionMakePrimary, emails, isFetching } = this.props;

    if (!isFetching) {
      actionMakePrimary(emails[index]);
    }
  };

  handleDelete = (index) => {
    const { emails, isFetching } = this.props;

    if (!isFetching) {
      this.setState({
        deleteModalEmail: emails[index],
        deleteModalIsOpen: true,
      });
    }
  };

  handleDeleteCancel = () => {
    this.setState({
      deleteModalEmail: null,
      deleteModalIsOpen: false,
    });
  };

  handleDeleteConfirm = async () => {
    const { deleteModalEmail } = this.state;
    const { actionDeleteEmail } = this.props;

    await actionDeleteEmail(deleteModalEmail);

    this.setState({
      deleteModalEmail: null,
      deleteModalIsOpen: false,
    });
  };

  handleResend = (index) => {
    const {
      actionResendConfirmation,
      actionReinitiateEmail,
      useOtpFlow,
      emails,
      isFetching,
    } = this.props;
    const { isReinitiating } = this.state;

    if (!isFetching) {
      if (useOtpFlow) {
        if (isReinitiating) return;

        const email = emails[index];
        this.setState({
          isReinitiating: true,
          verificationEmailAddress: email.address,
          pendingReinitiate: true,
        });
        actionReinitiateEmail(email.address).finally(() =>
          this.setState({ isReinitiating: false }),
        );
      } else {
        this.setState({
          confirmationModalEmail: emails[index],
          confirmationModalIsOpen: true,
        });
        actionResendConfirmation(emails[index]);
      }
    }
  };

  handleResendClose = () => {
    this.setState({
      confirmationModalEmail: '',
      confirmationModalIsOpen: false,
    });
  };

  handleVerificationSuccess = () => {
    const { actionFetchEmails, actionResetEmailState } = this.props;
    actionResetEmailState();
    this.setState(
      { verificationModalIsOpen: false, verificationEmailAddress: '' },
      () => {
        actionFetchEmails();
      },
    );
  };

  handleVerificationModalClose = () => {
    const { actionResetEmailState } = this.props;
    actionResetEmailState();
    this.setState({
      verificationModalIsOpen: false,
      verificationEmailAddress: '',
      pendingReinitiate: false,
    });
  };

  handleLockoutClose = () => {
    const { actionFetchEmails, actionResetEmailState } = this.props;
    actionResetEmailState();
    this.setState(
      {
        verificationModalIsOpen: false,
        verificationEmailAddress: '',
        pendingReinitiate: false,
      },
      () => {
        actionFetchEmails();
      },
    );
  };

  render() {
    const {
      deleteModalEmail,
      deleteModalIsOpen,
      confirmationModalEmail,
      confirmationModalIsOpen,
      verificationModalIsOpen,
      verificationEmailAddress,
    } = this.state;
    const { emails, isFetching, useOtpFlow, inspectionId } = this.props;

    return (
      <Fragment>
        <Emails
          emails={emails}
          isFetching={isFetching}
          handlePrimary={this.handlePrimary}
          handleResend={this.handleResend}
          handleDelete={this.handleDelete}
          useOtpFlow={useOtpFlow}
        />
        <EmailDeleteModal
          emails={emails}
          isOpen={deleteModalIsOpen}
          email={deleteModalEmail}
          handleCancel={this.handleDeleteCancel}
          handleConfirm={this.handleDeleteConfirm}
        />
        <EmailConfirmationModal
          isOpen={confirmationModalIsOpen}
          email={
            (confirmationModalEmail && confirmationModalEmail.address) || ''
          }
          handleCancel={this.handleResendClose}
        />
        <EmailVerificationModal
          isOpen={verificationModalIsOpen}
          closeModal={this.handleVerificationModalClose}
          inspectionId={inspectionId || ''}
          emailAddress={verificationEmailAddress}
          onVerifySuccess={this.handleVerificationSuccess}
          onLockoutClose={this.handleLockoutClose}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state.emails,
  useOtpFlow: !!state.featureFlags?.axp_779_verifications_emails_api,
});

const mapDispatchToProps = {
  actionReinitiateEmail: reinitiateEmail,
  actionDeleteEmail: deleteEmail,
  actionFetchEmails: fetchEmails,
  actionMakePrimary: makePrimary,
  actionResetEmailState: resetEmailState,
  actionResendConfirmation: resendConfirmation,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileEmails);
